document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(".bulk-form");
  const inputs = form.querySelectorAll(".bulk-form-quantity");
  const buttons = form.querySelectorAll(".quantity__button");
  const error = form.querySelector(".bulk-form-error");
  const submitButtons = form.querySelectorAll(".bulk-form-button");

  function checkInputs() {
    const disabled = Array.from(inputs).every((input) => {
      const value = input.value.trim();
      return value === "" || value === "0";
    });
    submitButtons.forEach((button) => {
      button.disabled = disabled;
    });
  }

  function toggleSubmitButtons(hasErrors) {
    submitButtons.forEach((button) => {
      if (hasErrors) {
        button.classList.add("is-disabled");
      } else {
        button.classList.remove("is-disabled");
      }
    });
    error.hidden = !hasErrors;
  }

  function displayErrorMessage(message) {
    error.hidden = false;
    error.textContent = message;
  }

  inputs.forEach((input) => {
    input.addEventListener("input", checkInputs);
    input.addEventListener("change", function () {
      const value = parseInt(this.value);
      const max = parseInt(this.getAttribute("max"));

      if (value > max) {
        this.parentNode.classList.add("is-over");
        this.dataset.error = "true";
      } else {
        this.parentNode.classList.remove("is-over");
        this.dataset.error = "false";
      }

      if (value === 0) {
        this.parentNode.classList.remove("is-true");
      } else {
        this.parentNode.classList.add("is-true");
      }

      const hasErrors = Array.from(inputs).some(
        (input) => input.dataset.error === "true"
      );
      toggleSubmitButtons(hasErrors);
    });
  });

  buttons.forEach((button) => {
    button.addEventListener("click", () => checkInputs());
  });

  submitButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();

      const formData = {
        items: Array.from(inputs)
          .map((inputElement) => {
            const quantity = parseInt(inputElement.value);
            if (quantity > 0) {
              return {
                id: inputElement.getAttribute("data-id"),
                quantity: quantity,
              };
            }
          })
          .filter((item) => item !== undefined),
      };

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();
        window.location.href = "/cart";
      } catch (error) {
        console.error("Error:", error);
        displayErrorMessage(
          "An error occurred while adding items to the cart."
        );
      }
    });
  });
});
